import { alpha } from '@mui/material'

export default function overrides(theme) {
    return {
        MuiTextField: {
            defaultProps: {
                size: "small",
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: ({ theme: t }) => ({
                    border: "1px solid",
                    borderColor: t.palette.divider,
                    '&:hover': {
                        borderColor: alpha(
                            t.palette.text.primary,
                            t.palette.action.focusOpacity
                        ),
                        '&.Mui-focused': {
                            borderColor: alpha(
                                t.palette.text.primary,
                                0.3
                            ),
                        },
                        '&.Mui-error': {
                            borderColor: alpha(
                                t.palette.error.main,
                                0.2
                            ),
                        },
                    },
                    '&.Mui-focused': {
                        borderColor: alpha(
                            t.palette.text.primary,
                            0.3
                        ),
                    },
                    '&.Mui-error': {
                        borderColor: alpha(
                            t.palette.error.main,
                            0.3
                        ),
                    },
                    '& fieldset': {
                        border: "none"
                    },
                    '& input': {
                    }
                })
            },
        },
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
            styleOverrides: {
                root: ({ theme: t }) => ({
                    position: "static",
                    transform: "none",
                    mb: 4,
                    ...t.typography.subtitle2,
                    color: t.palette.text.secondary,
                    '&.Mui-focused': {
                        color: t.palette.text.primary,
                    },
                    '&.Mui-error': {
                        color: t.palette.text.primary,
                    },
                })
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
            styleOverrides: {
                root: {
                    '&.MuiPaper-outlined': {
                    },
                },
            },
        },
        MuiButton: {
            defaultProps: {
                variant: 'contained',
                color: 'inherit',
                disableRipple: true,
            },
            styleOverrides: {
                root: ({ theme: t }) => ({
                    textTransform: 'none',
                    borderRadius: '4px',
                    boxShadow: 'none',
                    py: 2,
                    '&:hover': {
                        boxShadow: 'none',
                    },
                    '&.MuiButton-outlined': {
                        borderColor: alpha(t.palette.text.primary, 0.18),
                        backgroundColor: alpha(t.palette.background.paper, 0.7),
                        color: alpha(t.palette.text.primary, 0.78),
                        fontWeight: 600,
                    },
                    '&.MuiButton-outlined:hover': {
                        borderColor: alpha(t.palette.text.primary, 0.28),
                        backgroundColor: alpha(t.palette.text.primary, 0.03),
                        color: alpha(t.palette.text.primary, 0.88),
                    },
                }),
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    scrollbarWidth: 'thin',
                    scrollbarColor:
                        theme.palette.mode === 'dark'
                            ? `${theme.palette.grey[900]} ${theme.palette.grey[950]}`
                            : `${theme.palette.grey[200]} ${theme.palette.grey[50]}`,
                },
                body: {
                    scrollbarWidth: 'thin',
                    scrollbarColor:
                        theme.palette.mode === 'dark'
                            ? `${theme.palette.grey[800]} ${theme.palette.grey[900]}`
                            : `${theme.palette.grey[200]} ${theme.palette.grey[50]}`,
                },
            },
        },
    }
}
